import { render } from "./TopPythons.vue?vue&type=template&id=4cbced23"
import script from "./TopPythons.vue?vue&type=script&lang=js"
export * from "./TopPythons.vue?vue&type=script&lang=js"

import "./TopPythons.vue?vue&type=style&index=0&id=4cbced23&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__